import axios from '@/utils/request.js'

export const getGoodsList = () => { // 商品列表
  return axios.get('goods/gas/goods/getGoodsList')
}

export const addCompany = (params) => { // 添加公司
  return axios.post('goods/gas/company/add', params)
}
